function maRcpConfirmarCita(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.action) {
    const accionStore = 'setAccion';
    valorCambiaPanelLateral = 10;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maRcpSeleccionarCita(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.action) {
    const accionStore = 'setAccion';
    valorCambiaPanelLateral = 0;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maRcpEditarOrden(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.docId) {
    const accionStore = 'setIdFormulario';
    valorCambiaPanelLateral = 13;
    valor = response.docId;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maRcpTerminarEdicion(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.docId) {
    const accionStore = 'setIdFormulario';
    valorCambiaPanelLateral = 0;
    valor = null;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}

function maRcpEditarInfo(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.docId) {
    const accionStore = 'setIdFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.docId;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.consultar_formulario === 'si') {
    const accionStore = 'setConsultarFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.consultar_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
module.exports.recepcionEstados = function recepcionEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case 'ma_rcp_confirmar_cita':
        resolve(maRcpConfirmarCita(response));
        break;
      case 'ma_rcp_enviar_notificacion':
        resolve(maRcpSeleccionarCita(response));
        break;
      case 'ma_rcp_editar_orden':
        resolve(maRcpEditarOrden(response));
        break;
      case 'ma_rcp_editar_info':
        resolve(maRcpEditarInfo(response));
        break;
      case 'ma_rcp_terminar_edicion':
        resolve(maRcpTerminarEdicion(response));
        break;
      default:
        reject('Error');
        break;
    }
  });
};





// WEBPACK FOOTER //
// ./src/js/modulosChatBox/recepcion.js